const subServiceContent = {
  ipLifeCycleManagement: {
    title: "IP Life Cycle Management",
    subtitle: "Where Your Ideas Become Strategic Business Assets",
    description:
      "Innovation has no value unless it’s protected, managed, and aligned with business goals. LifeIntelect’s IP Lifecycle Management offers end-to-end solutions to transform ideas into market-ready, revenue-generating assets—whether at the seed stage or scaling globally.",

    service_1: {
      title: "IP Audit & Evaluation",
      subtitle: "Gain Clarity. Build Strength.",
      description:"A full-spectrum view of your intellectual property reveals untapped value and hidden risks—critical for making informed, strategic decisions.",
        processTitle: "Deliverables That Drive Impact:",
      process: [
          {
            description:
              "Comprehensive mapping of patents, trademarks, copyrights, designs, and trade secrets",
          },
          {
            description: "Strength and enforceability review for each asset",
          },
          {
            description:
              "Identification of expired, underutilized, or vulnerable IP",
          },
          {
            description: "Actionable risk mitigation and compliance frameworks",
          },
          {
            description:
              "Alignment of IP with business goals for sustainable scaling",
          },
        ],
        closing:"Turn oversight into opportunity with insights that inform long-term growth.",
    },

    service_2: {
      title: "IP Policy & Internal Frameworks",
      subtitle: "Secure Ideas. Empower Innovation",
      description:
        "A strong internal IP ecosystem protects ideas at every stage, fosters accountability, and builds a culture of innovation from within.",

      processTitle: "Frameworks That Enable Growth:",
      process: [
        {
          description:
            "Bespoke IP policies tailored to sector and strategic vision",
        },
        {
          description:
            "Streamlined processes for invention identification and protection",
        },
        {
          description: "Automated systems for renewals, deadlines, and audits",
        },
        {
          description: "Infringement response protocols and dispute readiness",
        },
        {
          description: "Training modules to embed IP literacy across teams",
        },
      ],
      closing:
        "Innovation thrives where systems support protection and ownership.",
    },
    service_3: {
      title: "IP Portfolio Management",
      subtitle: "Elevate Assets. Maximize ROI.",
      description:
        "Effective portfolio management turns static IP into a dynamic tool for business expansion, market entry, and competitive advantage.",

      processTitle: "Portfolio Actions that Matter:",
      process: [
        {
          description:
            "Valuation and performance audit of existing IP assets",
        },
        {
          description:"Strategic prioritization based on market potential and business alignment",
        },
        {
          description: "Exploration of licensing, joint ventures, and commercialization channels",
        },
        {
          description: "Continuous monitoring for infringements or market misuse",
        },
        {
          description: "Lifecycle tracking to prevent lapses and optimize renewals",
        },
      ],
      closing:"Let your IP portfolio power growth—not sit on the sidelines.",
    },
	service_4: {
      title: "IP Landscape & Market Intelligence",
      subtitle: "Act with Insight. Compete with Confidence.",
      description:"Informed decisions start with understanding who’s innovating, what’s protected, and where opportunities or threats lie.",
      processTitle: "What Market Clarity Looks Like:",
      process: [
        {
          description:
            "Patent analytics and competitor IP mapping for strategic positioning",
        },
        {
          description:"Identification of emerging players, partners, or acquisition targets",
        },
        {
          description: "Regulatory insights to navigate compliance across jurisdictions",
        },
        {
          description: "Citation and innovation trend analysis for technology benchmarking",
        },
      ],
      closing:"Make every move with clarity, confidence, and competitive foresight.",
    },
	service_5: {
      title: "IP-Based Research & Commercial Strategy",
      subtitle: "Bridge Innovation and Market Success.",
      description:"Strategic planning around IP assets turns potential into performance—by translating ownership into commercial outcomes.",
      processTitle: "Strategy That Converts:",
      process: [
        {
          description:
            "In-depth market research to identify unmet demand and niche potential",
        },
        {
          description:"Shortlisting of prospective licensees, acquirers, or JV partners",
        },
        {
          description: "Messaging and value proposition creation for tech transfer or partnerships",
        },
        {
          description: "Advisory support through deal structuring and closure",
        },
      ],
      closing:"IP isn’t just protected—it’s positioned to perform.",
    },
    subServices: {
		ipAudit: {
		  title: "IP Audit of the Company",
		  description:
			"At Lifeintelect, we conduct comprehensive IP audits to help you manage and optimize your intellectual property assets.",
			process: [
				{
				  title: "Understanding Your Business and IP Portfolio",
				  description:
					"We begin by understanding your business, its products, and its intellectual property portfolio. Our experts then conduct a thorough audit, reviewing all your IP assets, including patents, trademarks, copyrights, trade secrets, and design rights. We assess the strength, scope, and enforceability of each asset.",
				},
				{
				  title: "Comprehensive IP Audit Process",
				  description:
					"Next, we identify any gaps or risks in your IP portfolio, such as expired patents, unused trademarks, or unprotected innovations. We also evaluate the alignment of your IP strategy with your business goals, ensuring that your IP assets are being effectively utilized and protected.",
				},
				{
				  title: "Identifying Gaps and Aligning IP Strategy",
				  description:
					"We compile a detailed audit report, summarizing our findings and providing actionable recommendations to enhance your IP portfolio. This report includes strategies for optimizing IP management, improving IP protection, and leveraging IP assets for business growth.",
				},
			  ],
		  closing:
			"Lifeintelect’s IP audit service is designed to give you a clear understanding of your intellectual property landscape, allowing you to make informed decisions and maximize the value of your IP assets. Ready to audit your IP with Lifeintelect? Let's get started!",
		},
		ipLandscape:{
		title: "IP Landscape & Market Intelligence",
		subHeading: "IP Landscape & Market Intelligence",
      subTitle: "Act with Insight. Compete with Confidence.",
      description:"Informed decisions start with understanding who’s innovating, what’s protected, and where opportunities or threats lie.",
      processTitle: "What Market Clarity Looks Like:",
      process: [
        {
          description:
            "Patent analytics and competitor IP mapping for strategic positioning",
        },
        {
          description:"Identification of emerging players, partners, or acquisition targets",
        },
        {
          description: "Regulatory insights to navigate compliance across jurisdictions",
        },
        {
          description: "Citation and innovation trend analysis for technology benchmarking",
        },
      ],
      closing:"Make every move with clarity, confidence, and competitive foresight.",	
		},
		ipPolicy: {
		  title: "IP Policy & Internal Frameworks",
      subHeading: "IP Policy & Internal Frameworks",
      subTitle: "Secure Ideas. Empower Innovation.",
      description:"A strong internal IP ecosystem protects ideas at every stage, fosters accountability, and builds a culture of innovation from within.",
      processTitle: "Frameworks That Enable Growth:",
      process: [
        {
          description:"Bespoke IP policies tailored to sector and strategic vision",
        },
        {
          description:"Streamlined processes for invention identification and protection",
        },
        {
          description: "Automated systems for renewals, deadlines, and audits",
        },
        {
          description: "Infringement response protocols and dispute readiness",
        },
		{
          description: "Training modules to embed IP literacy across teams",
        },
      ],
      closing:"Innovation thrives where systems support protection and ownership",
		},
		ipResearch: {
      title: "IP-Based Research & Commercial Strategy",
      subHeading: "IP-Based Research & Commercial Strategy",
      subTitle: "Bridge Innovation and Market Success.",
      description:"Strategic planning around IP assets turns potential into performance—by translating ownership into commercial outcomes.",
      processTitle: "Strategy That Converts:",
      process: [
        {
          description:
            "In-depth market research to identify unmet demand and niche potential",
        },
        {
          description:"Shortlisting of prospective licensees, acquirers, or JV partners",
        },
        {
          description: "Messaging and value proposition creation for tech transfer or partnerships",
        },
        {
          description: "Advisory support through deal structuring and closure",
        },
      ],
      closing:"IP isn’t just protected—it’s positioned to perform.",
    },
		ipPortfolio: {
		  title: "IP Portfolio Management",
      subHeading: "IP Portfolio Management",
      subTitle: "Elevate Assets. Maximize ROI.",
      description:"Effective portfolio management turns static IP into a dynamic tool for business expansion, market entry, and competitive advantage.",
      processTitle: "Portfolio Actions that Matter:",
      process: [
        {
          description:"Valuation and performance audit of existing IP assets",
        },
        {
          description:"Strategic prioritization based on market potential and business alignment",
        },
        {
          description: "Exploration of licensing, joint ventures, and commercialization channels",
        },
        {
          description: "Continuous monitoring for infringements or market misuse",
        },
		{
          description: "Lifecycle tracking to prevent lapses and optimize renewals",
        },
      ],
      closing:"Let your IP portfolio power growth—not sit on the sidelines.",
		},
		ipValuation: {
		  title: "IP Valuation",
		  description:
			"At Lifeintelect, we offer thorough IP valuation services to help you understand the true worth of your intellectual property.",
		  description1:
			"We start by collecting detailed information about your IP assets, including patents, trademarks, copyrights, and trade secrets. Our experts then evaluate the legal, technical, and market aspects of each asset to determine its value.",
			valuationMethods: true,
			process: [
			{
			  title: "Cost-Based Valuation",
			  description:
				"Estimating the costs incurred in developing and maintaining the IP.",
			},
			{
			  title: "Market-Based Valuation",
			  description:
				"Comparing similar IP transactions in the market to determine the value.",
			},
			{
			  title: "Income-Based Valuation",
			  description:
				"Evaluating the revenue-generating potential of the IP.",
			},
		  ],
		  closing:
			"We compile a comprehensive valuation report that includes a detailed analysis of the IP assets, the valuation methodology used, and the estimated value. This report provides actionable insights that can be used for various business purposes, such as licensing, mergers and acquisitions, investment decisions, and financial reporting. Lifeintelect's IP valuation service is designed to give you a clear understanding of the monetary value of your intellectual property, supporting informed business decisions and maximizing the return on your IP investments. Ready to uncover the value of your IP with Lifeintelect? Let's get started!",
		},
		technologyTransfer: {
		  title: "Technology Transfer",
		  description:
			"At Lifeintelect, we facilitate seamless technology transfer to help you maximize the commercial potential of your innovations.",
		  description1:
			"We begin by identifying and evaluating the technology you wish to transfer. Our experts conduct a thorough assessment of its technical feasibility, market potential, and commercial viability. We then develop a strategic plan tailored to your business needs, outlining the best approach for transferring the technology.",
		  description2:
			"Next, we assist you in identifying potential partners, licensees, or buyers who can benefit from the technology. We manage negotiations and help draft licensing agreements or sale contracts to ensure your interests are protected and the terms are favorable.",
		  TransferTechnology:true,
			process: [
			{
			  title: "IP Protection",
			  description:
				"Ensuring that all intellectual property rights related to the technology are secured and maintained.",
			},
			{
			  title: "Documentation",
			  description:
				"Preparing all necessary documentation, including technical specifications, user manuals, and legal agreements.",
			},
			{
			  title: "Market Analysis",
			  description:
				"Conducting market research to identify potential applications and target markets for the technology.",
			},
			{
			  title: "Commercialization",
			  description:
				"Assisting with the commercialization strategy to bring the technology to market successfully.",
			},
		  ],
		  closing:
			"Lifeintelect’s technology transfer service is designed to help you unlock the full potential of your innovations, facilitating their adoption and use in the market. Ready to transfer your technology with Lifeintelect? Let's get started!",
		},
		ipAnalysis: {
		  title: "Analysis and due diligence",
		  description:
			"At Lifeintelect, we provide thorough analysis and due diligence services to ensure informed decision-making and strategic planning for your intellectual property.",
		  description1:
			"We start by gathering comprehensive information about your IP assets, including patents, trademarks, copyrights, and trade secrets. Our experts then conduct a detailed analysis to assess the strength, scope, and potential risks associated with each asset.",
		  description2:
			"Next, we perform due diligence to verify the ownership, validity, and enforceability of your IP.",
		  Provide:true,
			process: [
			{
			  title: "Legal Analysis",
			  description:
				"Reviewing the legal status of your IP to ensure there are no disputes or encumbrances.",
			},
			{
			  title: "Technical Analysis",
			  description:
				"Evaluating the technical aspects of your IP to determine its novelty, usability, and potential for improvement.",
			},
			{
			  title: "Market Analysis",
			  description:
				"Assessing the market potential and competitive landscape to understand the commercial value of your IP.",
			},
		  ],
		  closing:
		  	"We compile a comprehensive due diligence report that includes our findings, an assessment of potential risks, and actionable recommendations. This report helps you make informed decisions regarding mergers, acquisitions, licensing, or investments, ensuring your IP strategy aligns with your business goals.",
		  closing2:
			"Lifeintelect’s IP education service equips your team with the tools to safeguard your intellectual property and fosters a culture of innovation and compliance. Ready to educate your team with Lifeintelect? Let's get started!",
		},
		// ipEducation: {
		//   title: "IP Education",
		//   description:
		// 	"At Lifeintelect, we provide comprehensive IP education services to empower your team with the knowledge and skills needed to protect and manage intellectual property effectively. We offer tailored training programs that cover the fundamentals of IP, including patents, trademarks, copyrights, trade secrets, and more. Our experts work with you to understand your organization’s needs and develop customized workshops, seminars, or online courses that align with your business goals.",
		//   process: [
		// 	{
		// 	  title: "IP Awareness",
		// 	  description:
		// 		"Educating employees on the importance of intellectual property and its role in business success.",
		// 	},
		// 	{
		// 	  title: "IP Identification",
		// 	  description:
		// 		"Training teams to recognize potential IP assets within their work, such as inventions, designs, or creative content.",
		// 	},
		// 	{
		// 	  title: "IP Protection Strategies",
		// 	  description:
		// 		"Providing guidance on best practices for securing IP rights, including patent filings, trademark registrations, and confidentiality agreements.",
		// 	},
		// 	{
		// 	  title: "IP Compliance",
		// 	  description:
		// 		"Ensuring employees understand legal and regulatory requirements to avoid IP infringements.",
		// 	},
		//   ],
		//   closing:
		// 	"Lifeintelect’s IP education service equips your team with the tools to safeguard your intellectual property and fosters a culture of innovation and compliance. Ready to educate your team with Lifeintelect? Let's get started!",
		// },
	  },
  },
};

export default subServiceContent;
